import { EditOutlined, LayoutOutlined, PicRightOutlined } from '@ant-design/icons'
import { PublisherBean } from 'common/api/api.ts';
import { GoToReportButton } from 'common/components/GoToReportButton.tsx';
import { ListActionButton } from 'common/components/ListActionButton.tsx';
import { CommonRoutes } from 'common/context/commonRoutes';
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface Props {
  record: PublisherBean
}

export const PublisherActionBar: React.FC<Props> = ({ record }) => {
  const navigateTo = useNavigate()

  return (
    <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
      <ListActionButton tooltip="Sites" onClick={() => navigateTo(`${CommonRoutes.SITE}/${record.id}`)}>
        <PicRightOutlined />
      </ListActionButton>
      <ListActionButton tooltip="Ad Units" onClick={() => navigateTo(`${CommonRoutes.AD_UNIT}/${record.id}`)}>
        <LayoutOutlined />
      </ListActionButton>
      <GoToReportButton title="Reports" filterName="PublisherId" id={record.id} />
      <ListActionButton tooltip="Edit" onClick={() => navigateTo(`${CommonRoutes.PUBLISHER}/${record.id}/edit`)}>
        <EditOutlined />
      </ListActionButton>
    </div>
  )
}
